module.exports = __webpack_public_path__ + "static/media/task-inactive.cc39f804.svg";